
import * as yup from "yup";

export const SucursalesSchema = yup.object().shape({
    name: yup.string().required("Ingresa el nombre de la sucursales"),
    idBusinessName: yup.number().required("Selecciona el nombre de la empresa"),
});
